"use client";

import { useRouter } from "next/navigation";

import { Button } from "@/src/components/shadcn/ui/button";
import { useResumeWorkflowStepMutation, useWorkflowStepResumeCheck } from "@/src/lib/data-fetchers/tasks-fetchers";
import type { Task } from "@/src/models/task";
import { TaskStepStatus, type TaskStep } from "@/src/models/task-step";

export function WorkflowStepResumeButton({ task, step }: { task: Task; step: TaskStep }) {
  const check = useWorkflowStepResumeCheck(task);
  const resume = useResumeWorkflowStepMutation(task);
  const router = useRouter();
  const isRetry = step.status === TaskStepStatus.FAILED;
  const canResume = check.data?.resumable && check.data.taskStepId === step.id;

  return (
    <div className="space-y-3">
      {resume.error || check.error ? (
        <p className="text-sm text-destructive" role="alert">
          {resume.error?.message ?? check.error?.message}
        </p>
      ) : check.data && !check.data.resumable ? (
        <p className="text-sm text-muted-foreground">{check.data.reason}</p>
      ) : null}
      {check.isPending || check.error || canResume ? (
        <Button
          disabled={!canResume || resume.isPending || resume.isSuccess}
          onClick={() => resume.mutate(step.id, { onSettled: () => router.refresh() })}
        >
          {resume.isPending || resume.isSuccess ? (isRetry ? "Retrying…" : "Resuming…") : isRetry ? "Retry" : "Resume"}
        </Button>
      ) : null}
    </div>
  );
}
